import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Dashboard from "../app/dashboard/views/Dashboard.tsx";
import Login from "../app/auth/components/Login.tsx";
import SignUp from "../app/auth/components/SignUp.tsx";
import ForgotPassword from "../app/auth/components/ForgotPassword.tsx";
import AdminLayout from "../layouts/AdminLayout.tsx";
import Item from "../app/data_management/views/Item.tsx";
import Office from "../app/data_management/views/Office.tsx";
import Vendor from "../app/data_management/views/Vendor.tsx";
import Employee from "../app/data_management/views/Employee.tsx";
import Role from "../app/role/views/Role.tsx";
import ProtectedRoutes from "./ProtectedRoutes.tsx";

// Cek apakah user sudah login (cek token)
const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/*" element={<ProtectedRoutes />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="*" element={<Navigate to="/login" />} />
      {/* <Route path="/" element={<AdminLayout><Dashboard /></AdminLayout>} />
      <Route path="/data-management/item" element={<AdminLayout><Item /></AdminLayout>} />
      <Route path="/data-management/office" element={<AdminLayout><Office /></AdminLayout>} />
      <Route path="/data-management/vendor" element={<AdminLayout><Vendor /></AdminLayout>} />
      <Route path="/data-management/employee" element={<AdminLayout><Employee /></AdminLayout>} />
      <Route path="/role" element={<AdminLayout><Role /></AdminLayout>} /> */}
    </Routes>
  );
};

export default AppRoutes;
